import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "../ViewReport/index.css";
import CustomerPortalHeader from "../../components/Header/customerPortalHeader";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { cubejsApi } from "../../cubejs/CubeJsApi";
import Loader from "../../components/Loader/Loader";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import GetAppIcon from "@mui/icons-material/GetApp";

import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "./CustomerPortal.css";
import { getSFGBoxData } from "../SFGstore/services";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

const CustomerPortal = () => {
  const [fileUrl, setFileurl] = useState("");
  const uidLocation = useParams();
  const [Scale, setScale] = useState(calculateScale(window.screen.width));
  const [reportData, setReportData] = useState({});

  useEffect(() => {
    console.log("Scale", Scale);
  }, [Scale]);
  useEffect(() => {
    handleCubeJs();
  }, []);

  function calculateScale(screenWidth) {
    console.log("screenWidth", screenWidth);
    if (screenWidth < 450 && screenWidth > 350) {
      return 0.6;
    }
    if (screenWidth < 780 && screenWidth > 700) {
      return 1;
    }
    if (screenWidth > 800 && screenWidth < 900) {
      return 1.1;
    }
    if (screenWidth > 1500 && screenWidth < 1950) {
      return 1.8;
    }

    // Add more conditions as required
    return 1; // default scale
  }

  const handleCubeJs = async () => {
    if (uidLocation.id) {
      try {
        const BoxLabel = await cubejsApi.load({
          dimensions: [
            "GlovesPrintingBoxlabel.boxNo",
            "GlovesPrintingBoxlabel.boxLabelPdf",
          ],
          order: {
            "GlovesPrintingBoxlabel.boxNo": "asc",
          },
          filters: [
            {
              member: "GlovesPrintingBoxlabel.boxNo",
              operator: "equals",
              values: [uidLocation.id],
            },
          ],
        });

        const pdfView = BoxLabel.rawData().length
          ? "https://raychem-backend-storage.s3.amazonaws.com/media/reports/box_label_report/" +
            BoxLabel.rawData()[0]["GlovesPrintingBoxlabel.boxLabelPdf"]
          : null;
        setFileurl(pdfView);
      } catch (error) {
        console.log("error", error);
      }
    }
  };
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  function downloadFile(url, filename) {
    fetch(url)
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        const objectURL = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = objectURL;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(objectURL);
      });
  }

  const handledownload = () => {
    downloadFile(fileUrl, `${uidLocation.id}_box_report.pdf`);
  };

  useEffect(() => {
    handlegetData();
  }, [uidLocation.id]);

  const handlegetData = async () => {
    try {
      const resp = await getSFGBoxData(uidLocation.id);
      if (resp.status == 200) {
        setReportData(resp.data.payload);
      }
    } catch (error) {
      setReportData([]);
      console.log("error", error);
    }
  };
  return (
    <>
      <div
        className={
          uidLocation?.id && uidLocation.id.length == 13 ? "" : "send-docs"
        }
      >
        <div>
          <CustomerPortalHeader />
        </div>
        {uidLocation?.id && uidLocation.id.length == 13 ? (
          <div
            className="table-responsive"
            style={{ padding: "80px 24px 60px 24px" }}
          >
            <Table
              aria-label="Dipping parameter"
              className="dipping-parameter-table customer-portal-table"
            >
              <TableHead>
                <TableRow>
                  <TableCell>Box No.</TableCell>
                  <TableCell>Class</TableCell>
                  <TableCell>Size</TableCell>
                  <TableCell>Gloves Type</TableCell>
                  <TableCell>Length</TableCell>
                  <TableCell>Cuff</TableCell>
                  <TableCell>Lot No.</TableCell>
                  <TableCell>Quantity</TableCell>
                  <TableCell>Packed By</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
         
                  <TableRow >
                    <TableCell sx={{padding:"16px"}}>{reportData?.box_no}</TableCell>
                    <TableCell sx={{padding:"16px"}}>{reportData?.class_name}</TableCell>
                    <TableCell sx={{padding:"16px"}}>{reportData?.size_name}</TableCell>
                    <TableCell sx={{padding:"16px"}}>{reportData?.gloves_type}</TableCell>
                    <TableCell sx={{padding:"16px"}}>{reportData?.length}</TableCell>
                    <TableCell sx={{padding:"16px"}}>{reportData?.cuff}</TableCell>
                    <TableCell sx={{padding:"16px"}}>{reportData?.lot_no}</TableCell>
                    <TableCell sx={{padding:"16px"}}>{reportData?.quantity}</TableCell>
                    <TableCell sx={{padding:"16px"}}>{reportData?.created_by}</TableCell>
                  </TableRow>
               
              </TableBody>
            </Table>
          </div>
        ) : (
          <>
            <div className="send-email">
              <a
                className={fileUrl ? "send-report" : "send-email-report"}
                onClick={handledownload}
              >
                Download <GetAppIcon />
              </a>
            </div>
            <div className="pdf-viewer-email">
              {fileUrl && (
                <div className="pdf-viewer">
                  <Worker
                    workerUrl="https://unpkg.com/pdfjs-dist@2.13.216/build/pdf.worker.min.js"
                    className="boxpdf"
                  >
                    <div className="pdf-file-viewer">
                      <Viewer
                        fileUrl={fileUrl}
                        plugins={[defaultLayoutPluginInstance]}
                        defaultScale={Scale}
                      />
                    </div>
                  </Worker>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};
export default CustomerPortal;
